module.exports = __webpack_public_path__ + "static/media/windows_explorer.dc858fcb.ico";